import { render, staticRenderFns } from "./DocReduction.vue?vue&type=template&id=7d34bde8&"
import script from "./DocReduction.vue?vue&type=script&lang=js&"
export * from "./DocReduction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports